
// import './App.css';
import Sidenav from './component/Sidenav';
import 'bootstrap/dist/css/bootstrap.min.css';
import Content from './component/Content';


function App() {
  return (
   <>
<Sidenav/>
{/* <Content/> */}
   </>
  );
}

export default App;
